export enum DeviceStatus {
  ACTIVE = "active", NEGATIVE = "negative", INTERMEDIARY = "intermediary", POSITIVE = "positive", DISABLED = "disabled"
}
